// adds interactivity to the native <dialog> elements

document.addEventListener('DOMContentLoaded', () => {
  const $triggers = [...document.querySelectorAll('*[data-dialog-toggle]')];

  $triggers.forEach(($btn) => {
    $btn.addEventListener('click', (ev) => {
      event.stopPropagation();
      event.preventDefault();

      const $dialog = $btn.closest('dialog') || $btn.parentElement.querySelector('dialog');

      if ($dialog)
        if ($dialog.hasAttribute('open')) $dialog.close();
        else $dialog.showModal();
      else console.error('could not find a dialog to toggle', $btn);
    });
  });
});
